//NOTE: IMAGES MUST BE 16:9 to fit the grid formatting

//New Balance
//#region
export const newbalance_hero_800 = require('./img/2023/newbalance-23/newbalance-hero-800.jpg')
export const newbalance_hero_1920 = require('./img/2023/newbalance-23/newbalance-hero-1920.jpg')
export const newbalance_hero_3840 = require('./img/2023/newbalance-23/newbalance-hero-3840.jpg')

export const newbalance_1_800 = require('./img/2023/newbalance-23/newbalance-1-800.jpg')
export const newbalance_1_1920 = require('./img/2023/newbalance-23/newbalance-1-1920.jpg')
export const newbalance_1_3840 = require('./img/2023/newbalance-23/newbalance-1-3840.jpg')

export const newbalance_2_800 = require('./img/2023/newbalance-23/newbalance-2-800.jpg')
export const newbalance_2_1920 = require('./img/2023/newbalance-23/newbalance-2-1920.jpg')
export const newbalance_2_3840 = require('./img/2023/newbalance-23/newbalance-2-3840.jpg')

export const newbalance_3_800 = require('./img/2023/newbalance-23/newbalance-3-800.jpg')
export const newbalance_3_1920 = require('./img/2023/newbalance-23/newbalance-3-1920.jpg')
export const newbalance_3_3840 = require('./img/2023/newbalance-23/newbalance-3-3840.jpg')
//#endregion


//Sandaime Richard
//#region
export const richard_hero_800 = require('./img/2023/richard-23/richard-hero-800.jpg')
export const richard_hero_1920 = require('./img/2023/richard-23/richard-hero-1920.jpg')
export const richard_hero_3840 = require('./img/2023/richard-23/richard-hero-3840.jpg')

export const richard_1_800 = require('./img/2023/richard-23/richard-1-800.jpg')
export const richard_1_1920 = require('./img/2023/richard-23/richard-1-1920.jpg')
export const richard_1_3840 = require('./img/2023/richard-23/richard-1-3840.jpg')

export const richard_2_800 = require('./img/2023/richard-23/richard-2-800.jpg')
export const richard_2_1920 = require('./img/2023/richard-23/richard-2-1920.jpg')
export const richard_2_3840 = require('./img/2023/richard-23/richard-2-3840.jpg')

export const richard_3_800 = require('./img/2023/richard-23/richard-3-800.jpg')
export const richard_3_1920 = require('./img/2023/richard-23/richard-3-1920.jpg')
export const richard_3_3840 = require('./img/2023/richard-23/richard-3-3840.jpg')

export const richard_4_800 = require('./img/2023/richard-23/richard-4-800.jpg')
export const richard_4_1920 = require('./img/2023/richard-23/richard-4-1920.jpg')
export const richard_4_3840 = require('./img/2023/richard-23/richard-4-3840.jpg')

export const richard_5_800 = require('./img/2023/richard-23/richard-5-800.jpg')
export const richard_5_1920 = require('./img/2023/richard-23/richard-5-1920.jpg')
export const richard_5_3840 = require('./img/2023/richard-23/richard-5-3840.jpg')
//#endregion

//Attempted Rape of Susanna
//#region
export const susanna_hero_800 = require('./img/2023/susanna-23/susanna-hero-800.jpg')
export const susanna_hero_1920 = require('./img/2023/susanna-23/susanna-hero-1920.jpg')
export const susanna_hero_3840 = require('./img/2023/susanna-23/susanna-hero-3840.jpg')

export const susanna_1_800 = require('./img/2023/susanna-23/susanna-1-800.jpg')
export const susanna_1_1920 = require('./img/2023/susanna-23/susanna-1-1920.jpg')
export const susanna_1_3840 = require('./img/2023/susanna-23/susanna-1-3840.jpg')

export const susanna_2_800 = require('./img/2023/susanna-23/susanna-2-800.jpg')
export const susanna_2_1920 = require('./img/2023/susanna-23/susanna-2-1920.jpg')
export const susanna_2_3840 = require('./img/2023/susanna-23/susanna-2-3840.jpg')

export const susanna_3_800 = require('./img/2023/susanna-23/susanna-3-800.jpg')
export const susanna_3_1920 = require('./img/2023/susanna-23/susanna-3-1920.jpg')
export const susanna_3_3840 = require('./img/2023/susanna-23/susanna-3-3840.jpg')
//#endregion

//Abigial Williams
//#region
export const abigail_hero_800 = require('./img/2023/abigail-23/abigail-hero-800.jpg')
export const abigail_hero_1920 = require('./img/2023/abigail-23/abigail-hero-1920.jpg')
export const abigail_hero_3840 = require('./img/2023/abigail-23/abigail-hero-3840.jpg')

export const abigail_1_800 = require('./img/2023/abigail-23/abigail-1-800.jpg')
export const abigail_1_1920 = require('./img/2023/abigail-23/abigail-1-1920.jpg')
export const abigail_1_3840 = require('./img/2023/abigail-23/abigail-1-3840.jpg')

export const abigail_2_800 = require('./img/2023/abigail-23/abigail-2-800.jpg')
export const abigail_2_1920 = require('./img/2023/abigail-23/abigail-2-1920.jpg')
export const abigail_2_3840 = require('./img/2023/abigail-23/abigail-2-3840.jpg')

export const abigail_3_800 = require('./img/2023/abigail-23/abigail-3-800.jpg')
export const abigail_3_1920 = require('./img/2023/abigail-23/abigail-3-1920.jpg')
export const abigail_3_3840 = require('./img/2023/abigail-23/abigail-3-3840.jpg')

export const abigail_4_800 = require('./img/2023/abigail-23/abigail-4-800.jpg')
export const abigail_4_1920 = require('./img/2023/abigail-23/abigail-4-1920.jpg')
export const abigail_4_3840 = require('./img/2023/abigail-23/abigail-4-3840.jpg')

export const abigail_5_800 = require('./img/2023/abigail-23/abigail-5-800.jpg')
export const abigail_5_1920 = require('./img/2023/abigail-23/abigail-5-1920.jpg')
export const abigail_5_3840 = require('./img/2023/abigail-23/abigail-5-3840.jpg')

export const abigail_6_800 = require('./img/2023/abigail-23/abigail-6-800.jpg')
export const abigail_6_1920 = require('./img/2023/abigail-23/abigail-6-1920.jpg')
export const abigail_6_3840 = require('./img/2023/abigail-23/abigail-6-3840.jpg')

export const abigail_7_800 = require('./img/2023/abigail-23/abigail-7-800.jpg')
export const abigail_7_1920 = require('./img/2023/abigail-23/abigail-7-1920.jpg')
export const abigail_7_3840 = require('./img/2023/abigail-23/abigail-7-3840.jpg')

export const abigail_8_800 = require('./img/2023/abigail-23/abigail-8-800.jpg')
export const abigail_8_1920 = require('./img/2023/abigail-23/abigail-8-1920.jpg')
export const abigail_8_3840 = require('./img/2023/abigail-23/abigail-8-3840.jpg')
//#endregion

//Seen
//#region
export const seen_hero_800 = require('./img/2023/seen-23/seen-hero-800.jpg')
export const seen_hero_1920 = require('./img/2023/seen-23/seen-hero-1920.jpg')
export const seen_hero_3840 = require('./img/2023/seen-23/seen-hero-3840.jpg')

export const seen_1_800 = require('./img/2023/seen-23/seen-1-800.jpg')
export const seen_1_1920 = require('./img/2023/seen-23/seen-1-1920.jpg')
export const seen_1_3840 = require('./img/2023/seen-23/seen-1-3840.jpg')

export const seen_2_800 = require('./img/2023/seen-23/seen-2-800.jpg')
export const seen_2_1920 = require('./img/2023/seen-23/seen-2-1920.jpg')
export const seen_2_3840 = require('./img/2023/seen-23/seen-2-3840.jpg')

export const seen_3_800 = require('./img/2023/seen-23/seen-3-800.jpg')
export const seen_3_1920 = require('./img/2023/seen-23/seen-3-1920.jpg')
export const seen_3_3840 = require('./img/2023/seen-23/seen-3-3840.jpg')

export const seen_4_800 = require('./img/2023/seen-23/seen-4-800.jpg')
export const seen_4_1920 = require('./img/2023/seen-23/seen-4-1920.jpg')
export const seen_4_3840 = require('./img/2023/seen-23/seen-4-3840.jpg')

export const seen_5_800 = require('./img/2023/seen-23/seen-5-800.jpg')
export const seen_5_1920 = require('./img/2023/seen-23/seen-5-1920.jpg')
export const seen_5_3840 = require('./img/2023/seen-23/seen-5-3840.jpg')

export const seen_6_800 = require('./img/2023/seen-23/seen-6-800.jpg')
export const seen_6_1920 = require('./img/2023/seen-23/seen-6-1920.jpg')
export const seen_6_3840 = require('./img/2023/seen-23/seen-6-3840.jpg')
//#endregion

//Venus in Fur
//#region
export const venusinfur_hero_800 = require('./img/2023/venusinfur-23/venusinfur-hero-800.jpg')
export const venusinfur_hero_1920 = require('./img/2023/venusinfur-23/venusinfur-hero-1920.jpg')
export const venusinfur_hero_3840 = require('./img/2023/venusinfur-23/venusinfur-hero-3840.jpg')

export const venusinfur_1_800 = require('./img/2023/venusinfur-23/venusinfur-1-800.jpg')
export const venusinfur_1_1920 = require('./img/2023/venusinfur-23/venusinfur-1-1920.jpg')
export const venusinfur_1_3840 = require('./img/2023/venusinfur-23/venusinfur-1-3840.jpg')

export const venusinfur_2_800 = require('./img/2023/venusinfur-23/venusinfur-2-800.jpg')
export const venusinfur_2_1920 = require('./img/2023/venusinfur-23/venusinfur-2-1920.jpg')
export const venusinfur_2_3840 = require('./img/2023/venusinfur-23/venusinfur-2-3840.jpg')

export const venusinfur_3_800 = require('./img/2023/venusinfur-23/venusinfur-3-800.jpg')
export const venusinfur_3_1920 = require('./img/2023/venusinfur-23/venusinfur-3-1920.jpg')
export const venusinfur_3_3840 = require('./img/2023/venusinfur-23/venusinfur-3-3840.jpg')

export const venusinfur_4_800 = require('./img/2023/venusinfur-23/venusinfur-4-800.jpg')
export const venusinfur_4_1920 = require('./img/2023/venusinfur-23/venusinfur-4-1920.jpg')
export const venusinfur_4_3840 = require('./img/2023/venusinfur-23/venusinfur-4-3840.jpg')
//#endregion

//Les Paravents
//#region
export const paravents_hero_800 = require('./img/2024/paravents/paravents-hero-800.jpg')
export const paravents_hero_1920 = require('./img/2024/paravents/paravents-hero-1920.jpg')
export const paravents_hero_3840 = require('./img/2024/paravents/paravents-hero-3840.jpg')

export const paravents_1_800 = require('./img/2024/paravents/paravents-1-800.jpg')
export const paravents_1_1920 = require('./img/2024/paravents/paravents-1-1920.jpg')
export const paravents_1_3840 = require('./img/2024/paravents/paravents-1-3840.jpg')

export const paravents_2_800 = require('./img/2024/paravents/paravents-2-800.jpg')
export const paravents_2_1920 = require('./img/2024/paravents/paravents-2-1920.jpg')
export const paravents_2_3840 = require('./img/2024/paravents/paravents-2-3840.jpg')

export const paravents_3_800 = require('./img/2024/paravents/paravents-3-800.jpg')
export const paravents_3_1920 = require('./img/2024/paravents/paravents-3-1920.jpg')
export const paravents_3_3840 = require('./img/2024/paravents/paravents-3-3840.jpg')
//#endregion

//Monopoly
//#region
export const monopoly_hero_1920 = require('./img/2024/monopoly/monopoly-hero-1920.jpg')
//#endregion

//The Very Hungry Caterpillar Show
//#region
export const tvhc_hero_1920 = require('./img/2024/tvhc/tvhc-hero-1920.jpg')

export const tvhc_1_3840 = require('./img/2024/tvhc/tvhc_1_3840.jpg')
export const tvhc_1_1920 = require('./img/2024/tvhc/tvhc_1_1920.jpg')
export const tvhc_1_800 = require('./img/2024/tvhc/tvhc_1_800.jpg')

export const tvhc_2_3840 = require('./img/2024/tvhc/tvhc_2_3840.jpg')
export const tvhc_2_1920 = require('./img/2024/tvhc/tvhc_2_1920.jpg')
export const tvhc_2_800 = require('./img/2024/tvhc/tvhc_2_800.jpg')

export const tvhc_3_3840 = require('./img/2024/tvhc/tvhc_3_3840.jpg')
export const tvhc_3_1920 = require('./img/2024/tvhc/tvhc_3_1920.jpg')
export const tvhc_3_800 = require('./img/2024/tvhc/tvhc_3_800.jpg')

export const tvhc_4_3840 = require('./img/2024/tvhc/tvhc_4_3840.jpg')
export const tvhc_4_1920 = require('./img/2024/tvhc/tvhc_4_1920.jpg')
export const tvhc_4_800 = require('./img/2024/tvhc/tvhc_4_800.jpg')

export const tvhc_5_3840 = require('./img/2024/tvhc/tvhc_5_3840.jpg')
export const tvhc_5_1920 = require('./img/2024/tvhc/tvhc_5_1920.jpg')
export const tvhc_5_800 = require('./img/2024/tvhc/tvhc_5_800.jpg')

export const tvhc_6_3840 = require('./img/2024/tvhc/tvhc_6_3840.jpg')
export const tvhc_6_1920 = require('./img/2024/tvhc/tvhc_6_1920.jpg')
export const tvhc_6_800 = require('./img/2024/tvhc/tvhc_6_800.jpg')

export const tvhc_7_3840 = require('./img/2024/tvhc/tvhc_7_3840.jpg')
export const tvhc_7_1920 = require('./img/2024/tvhc/tvhc_7_1920.jpg')
export const tvhc_7_800 = require('./img/2024/tvhc/tvhc_7_800.jpg')

export const tvhc_8_3840 = require('./img/2024/tvhc/tvhc_8_3840.jpg')
export const tvhc_8_1920 = require('./img/2024/tvhc/tvhc_8_1920.jpg')
export const tvhc_8_800 = require('./img/2024/tvhc/tvhc_8_800.jpg')

export const tvhc_9_3840 = require('./img/2024/tvhc/tvhc_9_3840.jpg')
export const tvhc_9_1920 = require('./img/2024/tvhc/tvhc_9_1920.jpg')
export const tvhc_9_800 = require('./img/2024/tvhc/tvhc_9_800.jpg')

export const tvhc_10_3840 = require('./img/2024/tvhc/tvhc_10_3840.jpg')
export const tvhc_10_1920 = require('./img/2024/tvhc/tvhc_10_1920.jpg')
export const tvhc_10_800 = require('./img/2024/tvhc/tvhc_10_800.jpg')

export const tvhc_11_3840 = require('./img/2024/tvhc/tvhc_11_3840.jpg')
export const tvhc_11_1920 = require('./img/2024/tvhc/tvhc_11_1920.jpg')
export const tvhc_11_800 = require('./img/2024/tvhc/tvhc_11_800.jpg')
//#endregion

//Edinburgh Fringe
//#region
export const ed_fringe_25_hero_1920 = require('./img/2025/edinburgh/edinburgh25-hero-1920.jpg')

export const ed_fringe_25_1_3840 = require('./img/2025/edinburgh/edinburgh25_1_3840.jpg')
export const ed_fringe_25_1_1920 = require('./img/2025/edinburgh/edinburgh25_1_1920.jpg')
export const ed_fringe_25_1_800 = require('./img/2025/edinburgh/edinburgh25_1_800.jpg')

export const ed_fringe_25_2_3840 = require('./img/2025/edinburgh/edinburgh25_2_3840.jpg')
export const ed_fringe_25_2_1920 = require('./img/2025/edinburgh/edinburgh25_2_1920.jpg')
export const ed_fringe_25_2_800 = require('./img/2025/edinburgh/edinburgh25_2_800.jpg')

export const ed_fringe_25_3_3840 = require('./img/2025/edinburgh/edinburgh25_3_3840.jpg')
export const ed_fringe_25_3_1920 = require('./img/2025/edinburgh/edinburgh25_3_1920.jpg')
export const ed_fringe_25_3_800 = require('./img/2025/edinburgh/edinburgh25_3_800.jpg')

export const ed_fringe_25_4_3840 = require('./img/2025/edinburgh/edinburgh25_4_3840.jpg')
export const ed_fringe_25_4_1920 = require('./img/2025/edinburgh/edinburgh25_4_1920.jpg')
export const ed_fringe_25_4_800 = require('./img/2025/edinburgh/edinburgh25_4_800.jpg')

export const ed_fringe_25_5_3840 = require('./img/2025/edinburgh/edinburgh25_5_3840.jpg')
export const ed_fringe_25_5_1920 = require('./img/2025/edinburgh/edinburgh25_5_1920.jpg')
export const ed_fringe_25_5_800 = require('./img/2025/edinburgh/edinburgh25_5_800.jpg')

export const ed_fringe_25_6_3840 = require('./img/2025/edinburgh/edinburgh25_6_3840.jpg')
export const ed_fringe_25_6_1920 = require('./img/2025/edinburgh/edinburgh25_6_1920.jpg')
export const ed_fringe_25_6_800 = require('./img/2025/edinburgh/edinburgh25_6_800.jpg')

export const ed_fringe_25_7_3840 = require('./img/2025/edinburgh/edinburgh25_7_3840.jpg')
export const ed_fringe_25_7_1920 = require('./img/2025/edinburgh/edinburgh25_7_1920.jpg')
export const ed_fringe_25_7_800 = require('./img/2025/edinburgh/edinburgh25_7_800.jpg')
//#endregion

//Ouverture Freestyle Villette
//#region
export const ouverturefreestyle_hero_3840 = require('./img/2025/ouvertureFreestyle-25/ouverture-1-3840.jpg')

export const ouverturefreestyle_1_1920 = require('./img/2025/ouvertureFreestyle-25/ouverturefreestyle_1_1920.jpg')
export const ouverturefreestyle_1_800 = require('./img/2025/ouvertureFreestyle-25/ouverturefreestyle_1_800.jpg')

export const ouverturefreestyle_2_1920 = require('./img/2025/ouvertureFreestyle-25/ouverturefreestyle_2_1920.jpg')
export const ouverturefreestyle_2_800 = require('./img/2025/ouvertureFreestyle-25/ouverturefreestyle_2_800.jpg')

export const ouverturefreestyle_3_1920 = require('./img/2025/ouvertureFreestyle-25/ouverturefreestyle_3_1920.jpg')
export const ouverturefreestyle_3_800 = require('./img/2025/ouvertureFreestyle-25/ouverturefreestyle_3_800.jpg')
//#endregion

//King 2025
//#region
export const king_hero_3840 = require('./img/2025/king-25/king-25-hero-1920.jpg')

export const king25_1_3840 = require('./img/2025/king-25/king25_1_3840.jpg')
export const king25_1_1920 = require('./img/2025/king-25/king25_1_1920.jpg')
export const king25_1_800 = require('./img/2025/king-25/king25_1_800.jpg')

export const king25_2_3840 = require('./img/2025/king-25/king25_2_3840.jpg')
export const king25_2_1920 = require('./img/2025/king-25/king25_2_1920.jpg')
export const king25_2_800 = require('./img/2025/king-25/king25_2_800.jpg')

export const king25_3_3840 = require('./img/2025/king-25/king25_3_3840.jpg')
export const king25_3_1920 = require('./img/2025/king-25/king25_3_1920.jpg')
export const king25_3_800 = require('./img/2025/king-25/king25_3_800.jpg')

export const king25_4_3840 = require('./img/2025/king-25/king25_4_3840.jpg')
export const king25_4_1920 = require('./img/2025/king-25/king25_4_1920.jpg')
export const king25_4_800 = require('./img/2025/king-25/king25_4_800.jpg')
//#endregion

//Abigail Williams Reprise 2025
//#region
export const abigail25_hero_3840 = require('./img/2025/abigail-25/abigail25_hero_3840.jpg')
export const abigail25_hero_1920 = require('./img/2025/abigail-25/abigail25_hero_1920.jpg')
export const abigail25_hero_800 = require('./img/2025/abigail-25/abigail25_hero_800.jpg')

export const abigail25_1_3840 = require('./img/2025/abigail-25/abigail25_1_3840.jpg')
export const abigail25_1_1920 = require('./img/2025/abigail-25/abigail25_1_1920.jpg')
export const abigail25_1_800 = require('./img/2025/abigail-25/abigail25_1_800.jpg')

export const abigail25_2_3840 = require('./img/2025/abigail-25/abigail25_2_3840.jpg')
export const abigail25_2_1920 = require('./img/2025/abigail-25/abigail25_2_1920.jpg')
export const abigail25_2_800 = require('./img/2025/abigail-25/abigail25_2_800.jpg')

export const abigail25_3_3840 = require('./img/2025/abigail-25/abigail25_3_3840.jpg')
export const abigail25_3_1920 = require('./img/2025/abigail-25/abigail25_3_1920.jpg')
export const abigail25_3_800 = require('./img/2025/abigail-25/abigail25_3_800.jpg')

export const abigail25_4_3840 = require('./img/2025/abigail-25/abigail25_4_3840.jpg')
export const abigail25_4_1920 = require('./img/2025/abigail-25/abigail25_4_1920.jpg')
export const abigail25_4_800 = require('./img/2025/abigail-25/abigail25_4_800.jpg')

export const abigail25_5_3840 = require('./img/2025/abigail-25/abigail25_5_3840.jpg')
export const abigail25_5_1920 = require('./img/2025/abigail-25/abigail25_5_1920.jpg')
export const abigail25_5_800 = require('./img/2025/abigail-25/abigail25_5_800.jpg')

export const abigail25_6_3840 = require('./img/2025/abigail-25/abigail25_6_3840.jpg')
export const abigail25_6_1920 = require('./img/2025/abigail-25/abigail25_6_1920.jpg')
export const abigail25_6_800 = require('./img/2025/abigail-25/abigail25_6_800.jpg')
//#endregion

//Rappeuz
//#region
export const rappeuz25_hero_1920 = require('./img/2025/rappeuz-25/rappeuz25_hero_1920.jpg')
export const rappeuz25_hero_800 = require('./img/2025/rappeuz-25/rappeuz25_hero_800.jpg')

export const rappeuz25_1_1920 = require('./img/2025/rappeuz-25/rappeuz25_1_1920.jpg')
export const rappeuz25_1_800 = require('./img/2025/rappeuz-25/rappeuz25_1_800.jpg')

export const rappeuz25_2_1920 = require('./img/2025/rappeuz-25/rappeuz25_2_1920.jpg')
export const rappeuz25_2_800 = require('./img/2025/rappeuz-25/rappeuz25_2_800.jpg')

export const rappeuz25_3_1920 = require('./img/2025/rappeuz-25/rappeuz25_3_1920.jpg')
export const rappeuz25_3_800 = require('./img/2025/rappeuz-25/rappeuz25_3_800.jpg')

export const rappeuz25_4_1920 = require('./img/2025/rappeuz-25/rappeuz25_4_1920.jpg')
export const rappeuz25_4_800 = require('./img/2025/rappeuz-25/rappeuz25_4_800.jpg')
//#endregion

//T-Rex Spaghetti
//#region
export const trexspaghetti_hero_3840 = require('./img/2026/trexspaghetti/trexspaghetti_hero_3840.jpg')
export const trexspaghetti_hero_1920 = require('./img/2026/trexspaghetti/trexspaghetti_hero_1920.jpg')
export const trexspaghetti_hero_800 = require('./img/2026/trexspaghetti/trexspaghetti_hero_800.jpg')

export const trexspaghetti_1_3840 = require('./img/2026/trexspaghetti/trexspaghetti_1_3840.jpg')
export const trexspaghetti_1_1920 = require('./img/2026/trexspaghetti/trexspaghetti_1_1920.jpg')
export const trexspaghetti_1_800 = require('./img/2026/trexspaghetti/trexspaghetti_1_800.jpg')

export const trexspaghetti_2_3840 = require('./img/2026/trexspaghetti/trexspaghetti_2_3840.jpg')
export const trexspaghetti_2_1920 = require('./img/2026/trexspaghetti/trexspaghetti_2_1920.jpg')
export const trexspaghetti_2_800 = require('./img/2026/trexspaghetti/trexspaghetti_2_800.jpg')

export const trexspaghetti_3_3840 = require('./img/2026/trexspaghetti/trexspaghetti_3_3840.jpg')
export const trexspaghetti_3_1920 = require('./img/2026/trexspaghetti/trexspaghetti_3_1920.jpg')
export const trexspaghetti_3_800 = require('./img/2026/trexspaghetti/trexspaghetti_3_800.jpg')

export const trexspaghetti_4_3840 = require('./img/2026/trexspaghetti/trexspaghetti_4_3840.jpg')
export const trexspaghetti_4_1920 = require('./img/2026/trexspaghetti/trexspaghetti_4_1920.jpg')
export const trexspaghetti_4_800 = require('./img/2026/trexspaghetti/trexspaghetti_4_800.jpg')

export const trexspaghetti_5_3840 = require('./img/2026/trexspaghetti/trexspaghetti_5_3840.jpg')
export const trexspaghetti_5_1920 = require('./img/2026/trexspaghetti/trexspaghetti_5_1920.jpg')
export const trexspaghetti_5_800 = require('./img/2026/trexspaghetti/trexspaghetti_5_800.jpg')

export const trexspaghetti_6_1920 = require('./img/2026/trexspaghetti/trexspaghetti_6_1920.jpg')
export const trexspaghetti_6_800 = require('./img/2026/trexspaghetti/trexspaghetti_6_800.jpg')

export const trexspaghetti_7_1920 = require('./img/2026/trexspaghetti/trexspaghetti_7_1920.jpg')
export const trexspaghetti_7_800 = require('./img/2026/trexspaghetti/trexspaghetti_7_800.jpg')

export const trexspaghetti_8_1920 = require('./img/2026/trexspaghetti/trexspaghetti_8_1920.jpg')
export const trexspaghetti_8_800 = require('./img/2026/trexspaghetti/trexspaghetti_8_800.jpg')
//#endregion
